<template>
  <div class="detalhesAssinaturas">
    <div class="aguarde-container text-center" v-if="this.loading">
      <div class="spinner-border" role="status"></div>
      <br />
      <span>Aguarde...</span>
    </div>

    <div v-if="!loading">
      <div>
        <div class="
            align-items-lg-start
            d-flex
            flex-column flex-lg-row
            justify-content-center
            align-items-center
          " v-if="detail">
          <img v-if="detail.urlImagemPromocional" :src="detail.urlImagemPromocional" style="width: 15vw" />
          <div class="p-4 align-items-lg-start align-items-center">
            <div>
              <p style="font-size: 1.35em">
                {{ detail.nome }}
              </p>
              <p>
                {{ detail.nomeLoja }}
              </p>
              <div class="col-12">
                <strong style="font-size: 1.95em">
                  R$
                  {{
                      formatPrice(
                        modeloCobrancaSelecionado
                          ? modeloCobrancaSelecionado.valorTotal
                          : 0
                      )
                  }}
                  /
                  <span class="text-small text-italic text-lowercase" v-if="
                    modeloCobrancaSelecionado
                      ? modeloCobrancaSelecionado.recorrenciaPeriodicidadeTipo ==
                      'MENSAL'
                      : ''
                  ">mês</span>
                  <span class="text-small text-italic text-lowercase" v-if="
                    modeloCobrancaSelecionado
                      ? modeloCobrancaSelecionado.recorrenciaPeriodicidadeTipo ==
                      'TRIMESTRAL'
                      : ''
                  ">trimestre</span>
                  <span class="text-small text-italic text-lowercase" v-if="
                    modeloCobrancaSelecionado
                      ? modeloCobrancaSelecionado.recorrenciaPeriodicidadeTipo ==
                      'SEMESTRAL'
                      : ''
                  ">semestre</span>
                  <span class="text-small text-italic text-lowercase" v-if="
                    modeloCobrancaSelecionado
                      ? modeloCobrancaSelecionado.recorrenciaPeriodicidadeTipo ==
                      'ANUAL'
                      : ''
                  ">ano</span>
                </strong>
              </div>
              <small v-if="detail.dateRegistro" style="display: block; color: #979797">Data da assinatura:{{
                  this.$moment(detail.dateRegistro, "DD/MM/YYYY")
              }}</small>
              <small v-if="detailRecorrencia" class="py-2" style="display: block; color: #979797">
                Situação:
                <span v-if="detailRecorrencia.status == 'REGISTRADO'" class="badge badge-warning">PENDENTE</span>
                <span v-if="detailRecorrencia.status == 'INICIADO'" class="badge">ASSINATURA ATIVA</span>
                <span v-if="detailRecorrencia.status == 'CANCELADO_RECEBEDOR'" class="badge badge-danger">ASSINATURA
                  CANCELADA</span>
                <span v-if="detailRecorrencia.status == 'CANCELADO_PAGADOR'" class="badge badge-danger">ASSINATURA
                  CANCELADA</span>
              </small>
              <p v-html="detail.descricao"></p>
            </div>

          </div>
        </div>
        <div class="d-flex flex-column align-items-center text-danger" v-if="!modeloCobrancaSelecionado && submit">
          <label>Selecione a forma de pagamento!</label>
          <label v-if="mensagem">{{}}</label>
        </div>
        <div class="d-flex flex-column align-items-center text-danger" v-if="mensagem">
          <label>{{ mensagem }}</label>
        </div>
        <div v-if="!detailRecorrencia || detailRecorrencia.status === 'REGISTRADO'"
          class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between">
          <button class="btn btn_color_system px-5 mt-4 py-2" @click="$router.go(-1)">
            VOLTAR
          </button>
          <button class="btn btn_color_system px-5 mt-4 py-2" @click="assinar()">
            ASSINAR
          </button>
        </div>

        <div v-if="detailRecorrencia && detailRecorrencia.status && detailRecorrencia.status !== 'REGISTRADO'" class="
            mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between ">
          <button @click="cancelarAssinatura()" v-if="
            detailRecorrencia.status != 'CANCELADO_PAGADOR' &&
            detailRecorrencia.status != 'CANCELADO_RECEBEDOR'
          " class="btn btn-danger py-2 px-lg-5 mt-4">
            Cancelar Assinatura
          </button>
          <button class="btn btn_color_system py-2 px-lg-5 mt-4" @click="aceitarTermos()">
            Trocar forma de pagamento
            <span class="spinner-border grey ml-2" v-if="loading"></span>
          </button>
        </div>
      </div>

    </div>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>
import icons from "@/shared/components/SvgIcon.js";
import Loading from "@/components/Loading.vue";
import { APIService } from "../../APIService";
const apiService = new APIService();
export default {
  name: "DetalhesAssinatura",
  props: ["mostrarEndereco", "assinarPlano"],
  components: { Loading },
  data() {
    return {
      pagamentos: [],
      detail: {},
      detailRecorrencia: null,
      codigoRecorrencia: "",
      termos: false,
      loading: true,
      mensagem: "",
      objMinhaAssinatura: null,
      idAssinatura: this.$route.params.idAssinatura,
      idPlanoAssinatura: this.$route.params.idPlanoAssinatura,
      associados: this.$route.params.associados,
      modeloCobrancaSelecionado: null,
      submit: false,
      icons,
    };
  },
  created() {
    this.loading = true;
    apiService.obterAssinatura(this.idAssinatura).then((response) => {
      this.detail = response;
      this.modeloCobrancaSelecionado = this.detail.modeloCobranca;
    });

    if (this.idPlanoAssinatura > 0) {
      apiService
        .obterMinhaAssinaturaID(this.idPlanoAssinatura)
        .then((response) => {
          this.detailRecorrencia = response;
          if (this.associados == 1) {
            this.loading = true;
            this.$emit("goToStep", "associados");
          } else {
            this.loading = false;
          }
        });
    } else {
      this.loading = false;
    }
  },
  methods: {
    formatPrice(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    formatDate(date) {
      return this.$moment(date, "DD/MM/YYYY HH:mm:ss");
    },
    cancelarAssinatura() {
      this.loading = true;
      apiService
        .cancelarAssinatura(this.detailRecorrencia.codigoRecorrencia)
        .then(() => {
          this.$swal({
            title: "Solicitação de cancelamento",
            text: "Sua solicitação foi realizada com sucesso, em breve você receberá mais informações por e-mail.",
          }).then(() => {
            this.$router.push(`/assinaturas`);
            this.loading = false;
          });
        })
        .catch(() =>
          this.$swal({ text: "Não foi possível realizar o cancelamento" })
        );
    },

    assinar() {
      this.loading = true;
      apiService
        .obterPlanoSimulacao(this.idAssinatura)
        .then((res) => {
          this.$store.dispatch("simulacaoPlanoStorage", res);
          this.$router.push(`/planos/checkout`);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    assinarOld() {
      if (!this.modeloCobrancaSelecionado) {
        this.submit = true;
        return;
      }

      this.loading = true;
      apiService
        .assinarPlano(this.idAssinatura, this.modeloCobrancaSelecionado.id)
        .then((res) => {
          if (window.PIXEL_CODE) {
            window.fbq("track", "Subscribe", {
              value: this.detail.modeloCobranca.valorTotal,
              currency: "BRL",
              predicted_ltv: "0.00",
              content_name: this.detail.nome,
            });
          }

          if (res.result) {
            this.$router.push(
              `/assinatura-detalhes/${this.idAssinatura}/${res.result}`
            );

            let step = "pagamento"

            switch (this.modeloCobrancaSelecionado.formaPagamento) {
              case 'BOLETO':
                step = 'boleto';
                break;
              case 'PIX':
                step = 'pix'
                break;
              default:
                step = 'pagamento';
            }

            this.$emit("goToStep", step);

            if (this.modeloCobrancaSelecionado.formaPagamento === "BOLETO" || this.modeloCobrancaSelecionado.formaPagamento === "PIX") {
              this.assinaturaCriada();
            }

            this.$emit(".carregarCobranca", this.modeloCobrancaSelecionado);
          } else {
            this.mensagem =
              "Ocorreu um problema ao processar sua assinatura, tente novamente.";
          }
        })
        .catch((error) => {
          this.mensagem = error.response?.data?.message
            ? error.response.data.message
            : "Ocorreu um problema ao processar sua assinatura, tente novamente.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    aceitarTermos() {
      if (!this.modeloCobrancaSelecionado) {
        this.submit = true;
        return;
      }

      this.loading = true;
      this.handleShowTermos();
    },
    handleShowTermos() {
      this.$swal({
        title: "Termos e condições",
        html: `<div style="overflow: auto;max-height: 70vh;">${this.detail.regulamento}</div>`,
        confirmButtonText: "Aceitar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          if (this.mostrarEndereco) {
            this.$emit("goToStep", "endereco");
          } else {
            this.assinar();
          }
        } else {
          this.loading = false;
        }
      });
    },
    assinaturaCriada() {
      this.loading = true;
      this.$swal({
        title: "Parabéns!!!",
        text: "Sua assinatura foi criada com sucesso. Após o processamento do pagamento sua assinatura será ativada.",
        confirmButtonText: "ok",
      }).finally(() => (this.loading = false));
      if (window.PIXEL_CODE) {
        window.fbq("track", "Purchase", {
          value: this.detail.valorParcela,
          currency: "BRL",
          predicted_ltv: "0.00",
          content_name: this.detail.nome,
        });
      }
    },
  },
  watch: {
    assinarPlano: function () {
      this.assinar();
    },
  },
};
</script>

<style scoped lang="scss">
ul.timeline {
  list-style-type: none;
  position: relative;
}

ul.timeline:before {
  content: " ";
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 7;
}

ul.timeline>li {
  margin: 20px 0;
  padding-left: 20px;
}

ul.timeline>li:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #22c0e8;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 7;
}
</style>
